module.exports = __webpack_public_path__ + "static/media/button.14ce515d.wav";